import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import holderDataFormMeta, { IHolderDataFormMeta } from "./HolderDataFormMeta";
import cardDataFormMeta, { ICardDataFormMeta } from "./CardDataFormMeta";

export interface IRequestedCardFormMeta extends IHolderDataFormMeta, ICardDataFormMeta {
  
  schema: any;
}

const requestedCardFormMeta = {...holderDataFormMeta, ...cardDataFormMeta} as IRequestedCardFormMeta;

requestedCardFormMeta.schema = yup.object().shape(getValidationSchema(requestedCardFormMeta));

export default requestedCardFormMeta;